import { ProfileImage } from "../model/ProfileImage";

// Returns a safe URL for the profile image.
// Handles cases where the object is undefined, null, or has an empty filename.
export function getProfileImageUrl(profileImage: ProfileImage | undefined | null) {
  const fileName = profileImage?.fileName;
  if (!fileName) {
    return "/images/icon/no-image.svg";
  }

  return `${process.env.REACT_APP_IMAGE_URL}/${fileName}`;
}
